export class EmployeeRoleInput {
    id: string;
    name: string;
    color: string;
}
